import { render } from "./ks-block-title.vue?vue&type=template&id=4ffa3b3a"
import script from "./ks-block-title.vue?vue&type=script&lang=js"
export * from "./ks-block-title.vue?vue&type=script&lang=js"

import "./ks-block-title.vue?vue&type=style&index=0&id=4ffa3b3a&lang=css"
script.render = render

export default script